(ns frontend.view.loading
  (:require
   [frontend.routing :as routing]))

(defmethod routing/render-view :loading
  [_]
  ; fixme:
  [:div])

